import { useUrlFilter } from "@/composables/filter";
import type { FilterDefinition } from "@/services/filter";
import { useRoute } from "vue-router";
import type { Ref } from "vue";

type CollectiblesFilterConfig = {
  /** Used only to order path segments deterministically (by FilterDefinition.id) when writing the URL. */
  filterDefinitions?: Ref<FilterDefinition[]>;
};

/**
 * Collectibles-specific filter composable that adds categoryUrl handling.
 * Wraps the generic useUrlFilter with domain-specific functionality.
 */
export function useCollectiblesFilter(config: CollectiblesFilterConfig = {}) {
  const route = useRoute();

  // Category from route params
  const categoryUrl = computed(() => route.params.categoryUrl as string);

  // Use the generic URL filter
  const urlFilter = useUrlFilter({ filterDefinitions: config.filterDefinitions });

  return {
    categoryUrl,
    ...urlFilter,
  };
}
